import { useState } from 'react';

const faqs = [
  {
    q: '下载的安装包打不开怎么办？',
    a: '请确认已完整下载安装包。若提示“文件损坏”，建议重新通过瓜子影视APP下载官网获取，并保证网络稳定。',
  },
  {
    q: 'iOS 端安装后需要做什么？',
    a: '瓜子影视iOS官网最新下载安装完成后，若系统提示“未受信任的企业级开发者”，请前往「设置 - 通用 - VPN与设备管理」中信任该描述文件后再打开。',
  },
  {
    q: 'TV 版在电视上安装失败？',
    a: '瓜子影视TV版2026官方最新版下载后，部分电视需开启「允许安装未知来源应用」。可将安装包拷贝到 U 盘，通过电视文件管理器安装。',
  },
  {
    q: '下载是否收费？',
    a: '瓜子影视客户端下载与安装完全免费，通过官方渠道获取安装包即可，切勿从未知来源下载以免安装到仿冒软件。',
  },
];

export default function GuaziDownloadFaq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="w-full bg-background-100 px-4 md:px-6 py-16 md:py-24">
      <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs md:text-sm font-bold">
          <i className="ri-question-line text-base" />
          下载常见问题
        </span>
        <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
          安装前的常见疑问
        </h2>
      </div>

      <div className="max-w-3xl mx-auto flex flex-col gap-3 md:gap-4">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={item.q} className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
              >
                <span className="font-heading font-bold text-base md:text-lg text-foreground-950">{item.q}</span>
                <span className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 ${isOpen ? 'bg-primary-500 text-primary-950' : 'bg-background-200 text-foreground-700'}`}>
                  <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} />
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-5 md:px-6 md:pb-6 -mt-1">
                  <p className="text-sm text-foreground-600 leading-7">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}